import { alpha } from '@mui/material/styles';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';

import { getVideoImage } from 'my-core/attachment-utils';

import GatedContent from 'my-components/OnlineCourse/InCourseExperience/GatedContent';
import { AspectRatioWrapper } from 'my-components/VideoPlayer';

import Fade from '@mui/material/Fade';

import activityBackground from 'images/stock-photos/blurred-laptop.jpg';

const rootCss = ({ palette, spacing }) => ({
  '.CLB-wrapper': {
    padding: spacing(0, 2),
    display: 'flex',
    justifyContent: 'center',
  },
  '.CLB-fullSize': { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
  '.CLB-background': {
    backgroundColor: palette.background.paper,
    backgroundImage: `url(${activityBackground})`,
    backgroundPosition: 'left',
    backgroundSize: 'cover',

    filter: 'blur(7px)',
  },
  '.CLB-overlay': {
    backgroundColor: alpha(palette.primary.background, 0.2),
  },
  '.CLB-content': {
    zIndex: 1,
  },
});

const THUMBNAIL_RATE = 3000;
export default function CourseLessonBlocked({ className, courseLesson, slots, ...rest }) {
  const Gate = slots?.gate || GatedContent;

  const [imgIdx, setImgIdx] = useState(0);
  const posterImg = getVideoImage(courseLesson?.video_thumbnails, imgIdx);

  useEffect(() => {
    if (posterImg) {
      const nextImg = getVideoImage(courseLesson?.video_thumbnails, imgIdx + 1);
      const loadPromise = new Promise(resolve => {
        const img = new window.Image();
        img.src = nextImg;
        img.onload = resolve;
      });
      const timeoutPromise = new Promise(resolve => setTimeout(resolve, THUMBNAIL_RATE));
      let cancelled = false;
      Promise.all([loadPromise, timeoutPromise]).then(() => {
        if (cancelled) return;
        setImgIdx(nextImg === posterImg ? 0 : imgIdx + 1);
      });
      return () => {
        cancelled = true;
      };
    }
  }, [courseLesson, posterImg, imgIdx]);

  return (
    <AspectRatioWrapper className={className} css={rootCss} wrapperClassName="CLB-wrapper">
      <SwitchTransition mode="in-out">
        <Fade key={posterImg || 0} timeout={THUMBNAIL_RATE / 2 - 40}>
          <div
            className={classNames('CLB-fullSize', 'CLB-background')}
            style={posterImg ? { backgroundImage: `url(${posterImg})` } : undefined}
          />
        </Fade>
      </SwitchTransition>
      <div className={classNames('CLB-fullSize', 'CLB-overlay')} />
      <Gate {...rest} actionText="continue watching" activityText="Video" className="CLB-content" />
    </AspectRatioWrapper>
  );
}
